module.exports = __webpack_public_path__ + "img/f4.980db4db.png";